export const enum DISTANCE {
  MILE = 1000,
  FEET = 100,
}
